import { DiagnosticsQueryParams } from "../types/dialog-types";

/**
 * localStorage key used to hand a per-tag diagnostics query from the opener
 * (right-click "Display Diagnostics") to the freshly-created Diagnostics
 * webview. localStorage is shared across same-origin Tauri webviews, so this is
 * a reliable transport even when the window's URL query string is dropped
 * during window creation (which the `?tag=` URL param is not guaranteed to
 * survive). Consumed and cleared by the first DiagnosticsWindow to mount.
 */
export const PENDING_DIAG_TAG_QUERY_KEY = "tiger.pendingDiagTagQuery";

export interface PendingDiagTagQuery {
  turbine: string;
  tag: string;
}

/**
 * Build the diagnostics query params for a right-click "Display Diagnostics" on
 * a single tag, mirroring the C++ `diagnostics_shell_c::set_tag_query`
 * (diagnostics_dialog.cpp:6133): a Complete-Listing (QUERY_TYPE_TIME), online
 * (non-historical), all-severity query scoped to one `config:channel`, with the
 * message-id / text / area patterns cleared and the diag filter off.
 *
 * The C++ uses `get_all_severity_mask()`, so every base severity is selected
 * and all controller-alarm sources (Speedtronic / Sentinel / OPC) are enabled.
 */
export function buildTagDiagQueryParams(
  turbineConfig: string,
  channel: string,
): DiagnosticsQueryParams {
  return {
    turbine: turbineConfig,
    severity: ["Trip", "Critical", "Fault", "Warning", "Event", "Information"],
    queryType: "Complete Listing",
    filterType: "Off",
    messageId: "",
    messageText: "",
    messageArea: "",
    tagName: channel,
    latchCount: "25",
    turbineState: "All States",
    groupTurbine: false,
    groupArea: false,
    failedSensor: false,
    isHistorical: false,
    timeRange: { startDate: "", startTime: "", endDate: "", endTime: "" },
    speedtronicAlarms: { palarm: true, dalarm: true, event: true },
    sentinelAlarms: { trip: true, alarm: true },
    opcAlarms: { alarm: true, event: true },
  };
}
